import { ProjectCode } from '@constants'

export const privacypoliciesLinkMap: Record<string, string> = {
  [ProjectCode.DCS]: 'https://www.dogcatstar.com/terms',
  [ProjectCode.HM]: 'https://heromamapet.com/privacypolicies',
  [ProjectCode.LM]: 'https://litomon.com/隱私權政策',
  [ProjectCode.MNP]: 'https://ladynpet.com/privacy-policy',
  [ProjectCode.AQUA]: 'https://aquacorners.com/privacy-policy',
  [ProjectCode.PP]: 'https://purialpet.com/privacy-policy',
  [ProjectCode.PM]: 'https://pawswellpet.com/privacy-policy',
  [ProjectCode.YT]: 'https://yummytiger.com/privacy-policy',
}
export const intellectualLinkMap: Record<string, string> = {
  [ProjectCode.DCS]: 'https://www.dogcatstar.com/claim',
  [ProjectCode.HM]: 'https://heromamapet.com/intellectual',
  [ProjectCode.LM]: 'https://litomon.com/intellectual_property',
  [ProjectCode.MNP]: 'https://ladynpet.com/intellectualpropertyrights',
  [ProjectCode.AQUA]: 'https://aquacorners.com/intellectualproperty',
  [ProjectCode.PP]: 'https://purialpet.com/privacy-policy',
  [ProjectCode.PM]: 'https://pawswellpet.com/privacy-policy',
  [ProjectCode.YT]: 'https://yummytiger.com/privacy-policy',
}
/**
 * https://www.notion.so/shepherdtech/Line-Email-239a4b7afc88806a908bce425d25d57c
 */
export const merchantCustomerServiceLinkMap: Record<string, string> = {
  [ProjectCode.DCS]: 'https://line.me/R/ti/p/@fjv3410w',
  [ProjectCode.HM]: 'https://line.me/R/ti/p/@092egkjk',
  [ProjectCode.LM]: 'https://line.me/R/ti/p/@eqy7422w',
  [ProjectCode.MNP]: 'https://line.me/R/ti/p/@192eovda',
  [ProjectCode.AQUA]: 'https://line.me/R/ti/p/@335jumsc',
  [ProjectCode.RS]: 'https://line.me/R/ti/p/@rihshin',
  [ProjectCode.YT]: 'https://line.me/R/ti/p/@450qxjlb',
}

export const merchantCustomerServiceLineMap: Record<string, string> = {
  [ProjectCode.DCS]: '@fjv3410w',
  [ProjectCode.HM]: '@092egkjk',
  [ProjectCode.LM]: '@eqy7422w',
  [ProjectCode.MNP]: '@192eovda',
  [ProjectCode.AQUA]: '@335jumsc',
  [ProjectCode.RS]: '@rihshin',
  [ProjectCode.YT]: '@450qxjlb',
}
